/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_State_Wrong_AccountInputs */

const en_invite_state_wrong_account = /** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite was sent to another email address. Sign in with that address.`)
};

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const ar_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const he_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const ur_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const es_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const fr_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const de_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const pt_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const hi_invite_state_wrong_account = en_invite_state_wrong_account;

/** @type {(inputs: Invite_State_Wrong_AccountInputs) => LocalizedString} */
const bn_invite_state_wrong_account = en_invite_state_wrong_account;

/**
* | output |
* | --- |
* | "This invite was sent to another email address. Sign in with that address." |
*
* @param {Invite_State_Wrong_AccountInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_state_wrong_account = /** @type {((inputs?: Invite_State_Wrong_AccountInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_State_Wrong_AccountInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_state_wrong_account(inputs)
	if (locale === "he") return he_invite_state_wrong_account(inputs)
	if (locale === "ur") return ur_invite_state_wrong_account(inputs)
	if (locale === "es") return es_invite_state_wrong_account(inputs)
	if (locale === "fr") return fr_invite_state_wrong_account(inputs)
	if (locale === "de") return de_invite_state_wrong_account(inputs)
	if (locale === "pt") return pt_invite_state_wrong_account(inputs)
	if (locale === "hi") return hi_invite_state_wrong_account(inputs)
	if (locale === "bn") return bn_invite_state_wrong_account(inputs)
	return /** @type {LocalizedString} */ ("This invite was sent to another email address. Sign in with that address.")
});